/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645480629626,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"amount":0.2},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"UNDERLYING_PRICE_TRAIL","symbol":"XYZ"},
	"date": "2022-02-21T16:57:10.232-0500",
	"timestamp": "1645480630235"
}

 * @param {*} pluginTemplate 
 * @returns object with two feilds:
 * 1) amount (size of trail)
 */
export function underlyingPriceTrailParser(pluginTemplate) {
    const parsedObject = {
        amount: null
    }
    if(pluginTemplate) {
        parsedObject.amount=pluginTemplate.amount;
    }
    return parsedObject;
}